module.exports = __webpack_public_path__ + "img/ambulance.2c80c119.jpg";